import { CSSProperties } from "react";
import { colors } from "@aifi-ml/design-system-variables";
import { font } from "src/styles/themes";

export const styles: Record<string, CSSProperties> = {
  errorPanel: {
    backgroundColor: colors.light['color/surface/background/secondary'],
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '16px',
    position: 'relative',
  },
  errorCard: {
    backgroundColor: colors.light['color/surface/background/primary'],
    borderRadius: 12,
    padding: '48px 32px',
    width: '100%',
    maxWidth: 600,
    margin: '0 auto',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
    zIndex: 1,
  },
  errorCodeBackground: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, calc(-50% + 200px))',
    fontSize: 200,
    fontWeight: 700,
    opacity: 0.24,
    background: 'linear-gradient(180deg, #D0D6E2 0%, rgba(208, 214, 226, 0.24) 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
    zIndex: 0,
    pointerEvents: 'none',
    fontFamily: font.family.fromVariable,
  },
  iconWrapper: {
    display: 'flex',
    padding: 12,
    alignItems: 'center',
    gap: 8,
    borderRadius: 12,
    marginBottom: 32,
    position: 'relative',
    zIndex: 1,
  },
  errorTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: colors.light['color/text/general/primary'],
    marginBottom: 16,
    textAlign: 'center',
    fontFamily: font.family.fromVariable,
    position: 'relative',
    zIndex: 1,
    lineHeight: 'normal',
    letterSpacing: -0.6,
  },
  errorMessage: {
    fontSize: 15,
    color: colors.light['color/text/general/secondary'],
    marginBottom: 0,
    textAlign: 'center',
    lineHeight: 'normal',
    letterSpacing: -0.2,
    fontFamily: font.family.fromVariable,
    position: 'relative',
    zIndex: 1,
  },
  goBackLink: {
    background: 'none',
    border: 'none',
    color: colors.light['color/text/general/active'],
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: -0.4,
    textAlign: 'center',
    cursor: 'pointer',
    textDecoration: 'none',
    fontFamily: font.family.fromVariable,
    position: 'relative',
    zIndex: 1,
    padding: 0,
    marginTop: 48,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  goBackLinkHover: {
    textDecoration: 'underline',
  },
};
